import {useState} from 'react';
import {
    getFromStore,
    saveToStore,
    StorePath,
    storeSaveAction,
    useStoreActionsFromStore,
} from '../../services/store.service';
import {handleApiResponse, logJsError, sendMessage} from '../../services/api.service';
import {addLatestMessage} from '../../services/message.service';
import MessageModel from '../../models/message.model';
import {OUTGOING_ACTION, snippetService} from '../../services/snippet.service';
import {Settings} from '../../models/snippet-payload.model';
import {DEPARTMENT} from "../../models/department.enum";
import {capitalizeFirst} from '../../services/utils.service';

const DepartmentSelection = () => {

    const departmentUrls = (getFromStore(StorePath.SETTINGS) as Settings)?.gpt_settings?.department_selection.urls;
    const storeAction = useStoreActionsFromStore(storeSaveAction);
    const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];
    const [selectedDepartment, setSelectedDepartment] = useState('');

    const isSelected = (department: DEPARTMENT): boolean => {
        return selectedDepartment === department;
    };

    const handleDepartmentSelection = (department: DEPARTMENT): void => {
        const label = capitalizeFirst(department);
        snippetService.sendCtaClickMessage(label);
        setSelectedDepartment(department);
        switch (department) {
            case DEPARTMENT.SALES:
                handleMessage(DEPARTMENT.SALES);
                break;
            case DEPARTMENT.SERVICE:
            case DEPARTMENT.PARTS:
                handleRedirect(department);
                break;
        }
    };

    const handleMessage = (department: DEPARTMENT): void => {
        const typingTimeout = setTimeout(() => {
            saveToStore(storeAction, StorePath.AGENT_TYPING, true);
        }, 1300);
        sendMessage(department)
                .then(handleApiResponse)
                .then((data: any) => {
                    clearTimeout(typingTimeout);
                    addLatestMessage(data.messages, messages, storeAction);
                    saveToStore(storeAction, StorePath.AGENT_TYPING, false);
                })
                .catch((error) => {
                    logJsError(error);
                });
    };

    const handleRedirect = (department: DEPARTMENT): void => {
        const url = departmentUrls[department];
        if (url) {
            redirect(url);
        } else {
            handleMessage(department);
        }
    };

    const redirect = (url: string): void => {
        snippetService.sendMessage({
            action: OUTGOING_ACTION.OPEN_IN_SAME_TAB,
            payload: {
                url,
            },
        });
    };

    return (
            <div>
                <div className={'flex flex-col items-start'}>
                    {Object.values(DEPARTMENT).map((department) => (
                            <button key={department}
                                className={`my-1 ml-10 p-2 rounded-sm border cursor-pointer ${isSelected(department) ? 'bg-primary text-white' : ''}`}
                                onClick={() => handleDepartmentSelection(department)}
                                disabled={!!selectedDepartment}>
                            <span className="whitespace-pre-line capitalize" style={{wordBreak: 'break-word'}}>
                                {department}
                            </span>
                            </button>
                    ))}
                </div>
            </div>
    );
};

export default DepartmentSelection;

